import React, {useState} from 'react';
import {
  Autocomplete
} from '@material-ui/lab';
import {
  CircularProgress,
  TextField
} from '@material-ui/core';
import axios from 'axios';
import _ from 'lodash';

const UniversityAutocomplete = (props)=> {
  const[open,setOpen] = useState();
  const[universitiesOptions,setUniversitiesOptions] = useState( []);
  const[isLoading, setIsLoading] = useState( false);

  const handleOpen = (event, open) => {
    const { attributes } = props.item;

    if (open === true) {
      setIsLoading(true)
      axios.get(
          `/v1/admin/universities/filter`,
          {
            params: { ids: attributes.university_id },
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-Admin-User-Email': props.adminUserSession.email,
              'X-Admin-User-Token': props.adminUserSession.token
            }
          }
      ).then((response) => {
        const { status, universities } = response.data;

        if (status === 'ok') {
          setIsLoading(false)
          setUniversitiesOptions(universities)
          setOpen(open)
        }
      });
    } else {
      setOpen(false)
    }

  }

  const handleInputChangeAutocomplete = (event, itemType) => {
    event.persist();
    if (event.target.value !== '' && event.target.value.length < 3){
      return
    }
    debounceFilterInput(event);
  }

  const debounceFilterInput = _.debounce((event) => {
    setIsLoading(true)
    axios.get(
      `/v1/admin/universities/filter`,
      {
        params: { filter: event.target.value },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { status, universities } = response.data;

      if (status === 'ok') {
        setIsLoading(false)
        setUniversitiesOptions(universities)
        setOpen(open)
      }
    });
  }, 650)

  const handleOnChangeAutocomplete = (event, field, selectedValue) => {
    if (selectedValue) {
      switch (selectedValue.constructor.name) {
        case 'Array':
          selectedValue = (selectedValue.map((values) => values.id))
          break;
        default:
          selectedValue = selectedValue.id
          break;
      }
    }

    if(props.nestedFields){
      const event = {
        target: {
          name: 'university_id',
          type: 'select',
          value: selectedValue,
        }
      }

      props.nestedFieldChange(event, props.item);
    }
      // else {
    //   setState({
    //     [field]: selectedValue,
    //   })
    // }
  }

    const loadingUniversities = isLoading
    const { attributes } = props.item;

    return(
      <Autocomplete
        open={open}
        onOpen={(event) => handleOpen(event, true)}
        onClose={(event) => handleOpen(event, false)}
        onChange={(event, value) => handleOnChangeAutocomplete(event, 'universityId', value)}
        // getOptionSelected={(option, value) => option.id === value.id}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name || ''}
        defaultValue={{ id: attributes.university_id, name: attributes.university_name }} //FIX THIS
        options={universitiesOptions}
        loading={loadingUniversities}
        renderInput={(params) => (
          <TextField
            {...params}
            label="University Name"
            variant="outlined"
            onChange={(event) => handleInputChangeAutocomplete(event, 'titles')}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingUniversities ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    )
}

export default UniversityAutocomplete;